export default __webpack_public_path__ + "static/media/icon_pin.e2e1d1d5.svg";